import React from 'react'

import { useNavigation, useRoute } from '@react-navigation/native'
import { XStack } from '@zet/design-system/layout'
import { H5, SH3 } from '@zet/design-system/typography'

import { state } from '../../utils/types'

interface Props {
  title: string
  state: state
  disabled: boolean
}

const SectionTitle: React.FC<Props> = (props) => {
  const { title, state: stateFromProps, disabled } = props

  const navigation = useNavigation()
  const {
    params: { hash, state: stateFromParams },
  } = useRoute()

  const navigateToState = () => {
    const state = stateFromProps || stateFromParams // Use state from props if available, else from params
    if (!disabled) {
      navigation.replace('BrandsCC', {
        hash,
        state,
      })
    }
  }

  return (
    <XStack className="mb-4">
      <H5 className="flex-1">{title}</H5>
      <SH3 className="text-primary-100" onPress={navigateToState}>
        Edit
      </SH3>
    </XStack>
  )
}

export default SectionTitle
